import { Action } from 'redux';

import { MoveContents, MoveContentsSucceeded } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { IContentInfo } from '../models/IContentInfo';

export interface MoveContentsAction extends Action {
  contentArray: IContentInfo[];
}

export function moveContents(contentArray: IContentInfo[]): MoveContentsAction {
  return {
    type: MoveContents,
    contentArray: contentArray
  };
}

export const isMoveContentAction = isActionFactory<MoveContentsAction>(MoveContents);

export interface MoveContentsSucceededAction extends Action {}

export function moveContentsSucceeded(): MoveContentsSucceededAction {
  return {
    type: MoveContentsSucceeded
  };
}

export const isMoveContentSuceededAction = isActionFactory<MoveContentsSucceededAction>(MoveContentsSucceeded);
